<template>
  <div>
    <Header></Header>
    <div class="exam-wrapper">
      <div class="pro_header">
        <div class="modal_class">
          <div @click="onClickLeft" class="back_class">
            <img src="../../assets/img/fanhui.png" style="margin-right: 12px;width: 20px;height: 20px;"/>
            <div>返回</div>
          </div>
          <!-- <div style="margin-left: 50px;" class="title_class">
            {{ categoryName }}
          </div>
          <div style="margin: 0 20px;"> <img src="../../assets/img/navbar.png"/> </div> -->
          <div class="title_class">{{ chaName }}</div>
        </div>
      </div>
      <div class="wrap">
        <div class="topic">
          <div class="question_type">
            <div style="display: flex; align-items: center">
              <div class="identify"></div>
              <span class="name">
                {{
                  docType == 1
                    ? "单选题"
                    : docType == 2
                    ? "多选题"
                    : docType == 3
                    ? "判断题"
                    : docType == 4
                    ? "不定项"
                    : docType == 5
                    ? "主观题"
                    : "综合题"
                }}
                  <!-- {{ indexNum }}  -->
                  {{ currentNum }}
                  /
                  <!-- {{ numArr.length != 0 ? numArr[docType - 1] : 0 }} -->
                  {{ listQu.length }}
                </span>
            </div>
          </div>
          <div class="content_wrap">
            <div class="content_inner">
              <div style="margin-right: 20px">
                <!-- 解析样式多选 -->
                <div class="question_content" v-if="docType != 6">
                  <div class="title information_class" v-html="detail.content"></div>
                  <img :src="detail.pic" v-if="detail.pic" style="width: 100%;margin-left: 10px;"/>
                  <div class="option_content">
                    <el-checkbox-group
                      v-if="docType != 5 && docType != 6"
                      v-model="result"
                      @change="groupChange"
                    >
                      <el-checkbox
                        :key="index"
                        v-for="(item, index) in detail.answerList"
                        :class="{
                          'box-item': true,
                          'box-item-blue': checkColor(item) == 'blue',
                          'box-item-green': checkColor(item) == 'green',
                          'box-item-red': checkColor(item) == 'red',
                        }"
                        :label="item"
                      >
                        <div style="display: flex; align-items: center">
                          <img class="img-icon" :src="checkBoxImg('', item)" />
                          <span
                            :class="{
                              'box-text': true,
                              'box-text-blue': checkColor(item) == 'blue',
                              'box-text-green': checkColor(item) == 'green',
                              'box-text-red': checkColor(item) == 'red',
                            }"
                            >
                            <span>{{ item.abc }}.</span>
                            <span>
                              <span v-html="item.content"></span>
                              <img :src="item.apic" v-if="item.apic" style="width: 100%;"/>
                            </span>
                          </span>
                        </div>
                      </el-checkbox>

                      <div
                        @click="chakanjiexi"
                        class="duoxuanti"
                        v-if="ischecked && docType != 1 && docType != 3"
                      >
                        确定
                      </div>
                    </el-checkbox-group>
                    <div v-else-if="docType == 5 && !jxLoading">
                      <textarea
                        @blur="groupChange2"
                        placeholder="点击此处作答"
                        v-model="answerstr"
                        class="zg_con"
                      ></textarea>
                      <div
                        @click="chakanjiexi"
                        class="duoxuanti"
                        v-if="ischecked && docType != 1 && docType != 3"
                      >
                        确定
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="pars_content" v-if="jxLoading && docType != 5 && docType != 6">
                <!-- <div class="pars_title"> -->
                <!-- pars_title_success 正确样式 -->
                <div
                  :class="
                    cureCode == ansersCode ? 'pars_title_success' : 'pars_title'
                  "
                >
                  {{ cureCode == ansersCode ? "回答正确" : "回答错误" }}
                  <i class="el-icon-check" style="font-size: 20px; color: #fff;" v-if="cureCode == ansersCode"></i>
                  <i class="el-icon-close" style="font-size: 20px; color: #fff;" v-else></i>
                  <!-- <el-icon size="20" style="margin-left: 5px;">
                    <Select v-if="cureCode == ansersCode" style="color: #fff"/>
                    <CloseBold v-else style="color: #fff" />
                  </el-icon> -->
                </div>
                <div class="pars_middle">
                  <div class="pars_answer">
                    <div
                      class="pars_inner"
                      style="border-right: 1px solid #e1e1e1"
                    >
                      <div class="pars_text">正确答案</div>
                      <div class="pars_text_success">{{ cureCode }}</div>
                    </div>
                    <div class="pars_inner">
                      <div class="pars_text">我的答案</div>
                      <div class="pars_text_info">{{ ansersCode }}</div>
                    </div>
                  </div>
                  <div class="view_resolu_wrap">
                    <div class="view_resolut" v-if="false">
                      <img
                        src="../../assets/img/neirong.png"
                        style="width: 24px; height: 28px; margin-right: 11px"
                      />
                      查看解析
                    </div>
                    <div @click="collapseHandler">
                      <i class="el-icon-caret-bottom" style="font-size: 20px;color: #666;" v-if="!isReferenAnalysis"></i>
                      <i class="el-icon-caret-top" style="font-size: 20px;color: #666;" v-else></i>
                      <!-- <el-icon>
                        <CaretBottom
                          v-if="!isReferenAnalysis"
                          style="color: #666"
                        />
                        <CaretTop v-else style="color: #666" />
                      </el-icon> -->
                      {{ isReferenAnalysis ? "收起解析" : "展开解析" }}
                    </div>
                  </div>
                </div>
                <div class="reference_class" v-if="isReferenAnalysis">
                  <div class="reference_top">
                    <div class="reference_title">
                      <img src="../../assets/img/jiexi.png" />
                      参考解析
                    </div>
                    <!-- <div style="cursor: pointer" @click="closeAnalysis">
                      <el-icon></el-icon>
                    </div> -->
                  </div>
                  <div class="reference_p information_class" v-html="detail.analysis"></div>
                  <div v-if="detail.knowledgeName" class="reference_title_two">
                    <img src="../../assets/img/zhishidian.png" />
                    相关知识点
                  </div>
                  <div class="reference_bottom" v-if="detail.knowledgeName">
                    {{ detail.knowledgeName }}
                  </div>
                </div>
              </div>
              <div class="pars_content" v-if="jxLoading && docType == 5">
                <div style="min-height: 110px;background: #f8f8f8;border-radius:8px;padding-right: 19px;padding: 15px;">
                  <div style="width: 100%;">
                    <div  style="width: 120px;font-size: 18px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #303b45;">我的答案</div>
                    <span style="font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #eb6c48;display: inline-block;max-width: 470px;padding: 0 15px;word-wrap: break-word;">
                      {{ detail.answer || answerstr }}
                    </span>
                  </div>
                </div>
                <div class="reference_class" v-if="jxLoading">
                  <div class="reference_top">
                    <div class="reference_title">
                      <img src="../../assets/img/jiexi.png" />
                      参考解析
                    </div>
                    <!-- <div style="cursor: pointer" @click="closeAnalysis">
                      <el-icon></el-icon>
                    </div> -->
                  </div>
                  <div class="reference_p information_class" v-html="detail.analysis"></div>
                  <div v-if="detail.knowledgeName" class="reference_title_two">
                    <img src="../../assets/img/zhishidian.png" />
                    相关知识点
                  </div>
                  <div class="reference_bottom" v-if="detail.knowledgeName">
                    {{ detail.knowledgeName }}
                  </div>
                </div>
              </div>
              <div class="information_wrap" v-if="docType == 6">
                <div>
                  <div class="information_title">
                    <div>资料区</div>
                    <img v-if="dataAreaShow" src="../../assets/img/xzdakai.png" @click="dataAreaClick" style="width: 16px;height: 16px;cursor: pointer;margin-top: 7px;"/>
                    <img v-else src="../../assets/img/xzguanbi.png" @click="dataAreaClick" style="width: 16px;height: 16px;cursor: pointer;margin-top: 7px;"/>
                  </div>
                  <div class="information_class" v-html="detail.content" v-if="dataAreaShow"></div>
                </div>
                <el-divider v-if="!dataAreaShow"/>
                <div style="margin-top: 10px;">
                  <div class="answer_class">
                    <div>答题区</div>
                    <!-- <div>66</div> -->
                  </div>
                  <div class="page">
                    <div class="btns" v-for="(item, index) in detail.quSubList" :class="{ act: isChange === index }" @click="changeAsk(index,item)">
                      要求{{ index + 1 }}
                    </div>
                  </div>
                  <!-- 解析样式多选 -->
                  <div class="question_content">
                    <div class="page_text information_class" v-html="askdetail.content"></div>
                    <div class="option_content">
                      <el-checkbox-group
                        v-if="docTypeCom != 5"
                        v-model="resultCom"
                        @change="groupChangeCom"
                      >
                        <el-checkbox
                          :key="index"
                          v-for="(item, index) in askdetail.answerList"
                          :class="{
                            'box-item': true,
                            'box-item-blue': checkColorCom(item) == 'blue',
                            'box-item-green': checkColorCom(item) == 'green',
                            'box-item-red': checkColorCom(item) == 'red',
                          }"
                          :label="item"
                        >
                          <div style="display: flex; align-items: center">
                            <img class="img-icon" :src="checkBoxImgCom('', item)" />
                            <span
                              :class="{
                                'box-text': true,
                                'box-text-blue': checkColorCom(item) == 'blue',
                                'box-text-green': checkColorCom(item) == 'green',
                                'box-text-red': checkColorCom(item) == 'red',
                              }"
                              >
                              <span>{{ item.abc }}.</span>
                              <span>
                                <span v-html="item.content"></span>
                                <img :src="item.apic" v-if="item.apic" style="width: 100%;"/>
                              </span>
                            </span>
                          </div>
                        </el-checkbox>

                        <div
                          @click="chakanjiexi"
                          class="duoxuanti"
                          v-if="ischecked && docTypeCom != 1 && docTypeCom != 3"
                        >
                          确定
                        </div>
                      </el-checkbox-group>
                      <div v-show="(docTypeCom == 5 && !jxLoadingCom)">
                        <div id="demo1" style="margin-top: 5px;width: calc(105%);"></div>
                        <div
                          @click="chakanjiexi"
                          class="duoxuanti"
                          v-if="ischecked && docTypeCom != 1 && docTypeCom != 3"
                        >
                          确定
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="pars_content" v-if="jxLoadingAll && docTypeCom != 5 && docTypeCom != 6">
                    <div
                      :class="
                        cureCodeCom == ansersCodeCom ? 'pars_title_success' : 'pars_title'
                      "
                    >
                      {{ cureCodeCom == ansersCodeCom ? "回答正确" : "回答错误" }}
                      <i class="el-icon-check" style="font-size: 20px; color: #fff;" v-if="cureCodeCom == ansersCodeCom"></i>
                      <i class="el-icon-close" style="font-size: 20px; color: #fff;" v-else></i>
                      <!-- <el-icon size="20" style="margin-left: 5px;">
                        <Select v-if="cureCodeCom == ansersCodeCom" style="color: #fff"/>
                        <CloseBold v-else style="color: #fff" />
                      </el-icon> -->
                    </div>
                    <div class="pars_middle">
                      <div class="pars_answer">
                        <div
                          class="pars_inner"
                          style="border-right: 1px solid #e1e1e1"
                        >
                          <div class="pars_text">正确答案</div>
                          <div class="pars_text_success">{{ cureCodeCom }}</div>
                        </div>
                        <div class="pars_inner">
                          <div class="pars_text">我的答案</div>
                          <div class="pars_text_info">{{ ansersCodeCom }}</div>
                        </div>
                      </div>
                      <div class="view_resolu_wrap">
                        <div class="view_resolut" v-if="false">
                          <img
                            src="../../assets/img/neirong.png"
                            style="width: 24px; height: 28px; margin-right: 11px"
                          />
                          查看解析
                        </div>
                        <div @click="collapseHandler">
                          <i class="el-icon-caret-bottom" style="font-size: 20px;color: #666;" v-if="!isReferenAnalysis"></i>
                          <i class="el-icon-caret-top" style="font-size: 20px;color: #666;" v-else></i>
                          <!-- <el-icon>
                            <CaretBottom
                              v-if="!isReferenAnalysis"
                              style="color: #666"
                            />
                            <CaretTop v-else style="color: #666" />
                          </el-icon> -->
                          {{ isReferenAnalysis ? "收起解析" : "展开解析" }}
                        </div>
                      </div>
                    </div>
                    <div class="reference_class" v-if="isReferenAnalysis">
                      <div class="reference_top">
                        <div class="reference_title">
                          <img src="../../assets/img/jiexi.png" />
                          参考解析
                        </div>
                        <!-- <div style="cursor: pointer" @click="closeAnalysis"></div> -->
                      </div>
                      <div class="reference_p information_class" v-html="detail.analysis"></div>
                      <div v-if="detail.knowledgeName" class="reference_title_two">
                        <img src="../../assets/img/zhishidian.png" />
                        相关知识点
                      </div>
                      <div class="reference_bottom" v-if="detail.knowledgeName">
                        {{ detail.knowledgeName }}
                      </div>
                    </div>
                  </div>
                  <div class="pars_content" v-if="jxLoadingCom && docTypeCom == 5">
                    <div style="min-height: 110px;background: #f8f8f8;border-radius: 8px;padding-right: 19px;padding: 15px;">
                      <div>
                        <div style="width: 120px;font-size: 18px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #303b45;">我的答案</div>
                        <!-- <div v-html="editorData" style="word-wrap: break-word;font-size: 16px;font-family: PingFangSC-Semibold, PingFang SC;font-weight: 600;color: #eb6c48;"></div> -->
                        <div id="demo2" class="demo_class" style="margin-top: 5px;width: calc(100%);"></div>
                      </div>
                    </div>
                    <div class="reference_class" v-if="jxLoadingCom">
                      <div class="reference_top">
                        <div class="reference_title">
                          <img src="../../assets/img/jiexi.png" />
                          参考解析
                        </div>
                        <!-- <div style="cursor: pointer" @click="closeAnalysis"></div> -->
                      </div>
                      <div class="reference_p information_class" v-html="detail.analysis"></div>
                      <div v-if="detail.knowledgeName" class="reference_title_two">
                        <img src="../../assets/img/zhishidian.png" />
                        相关知识点
                      </div>
                      <div class="reference_bottom" v-if="detail.knowledgeName">
                        {{ detail.knowledgeName }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="question_btn">
              <div class="left_btn">
                <div plain @click="lastTopic()">上一题</div>
                <div plain @click="nextTopic()">下一题</div>
              </div>
              <div class="right_analysis" @click="openJie()" v-if="false">
                <div>
                  <img
                    src="../../assets/img/neirong.png"
                    style="
                      width: 20px;
                      height: 23px;
                      position: relative;
                      top: -2px;
                    "
                  />
                </div>
                <div style="margin-left: 5px">解析</div>
              </div>
            </div>
          </div>
        </div>
        <div class="option">
          <!-- 模拟试题有 -->
          <!--  v-if="practiceTestShow" -->
          <div class="answer_timer">
            <div class="answer_type">
              <div class="identify"></div>
              <i class="el-icon-alarm-clock" style="margin-left: 20px; color: #666; font-size: 30px;"></i>
              <!-- <el-icon size="25" style="margin-left: 20px;">
                <AlarmClock style="color: #666;"/>
              </el-icon> -->
              <span class="name">答题时间：</span>
            </div>
            <div style="display: inline-block;font-size: 23px;font-family: PingFangSC-Medium, PingFang SC;font-weight: 500;color: #666;">
              {{ name }}
            </div>
            <!-- <el-countdown :value="name" /> -->
          </div>
          <div
            class="option_wrap"
            :style="{ height: practiceTestShow ? 'calc(100% - 97px)' : '100%' }"
          >
            <div style="height: 100%;">
              <div class="question_type_right" style="margin-top: 24px">
                <div style="display: flex; align-items: center">
                  <div class="identify"></div>
                  <span class="name" style="margin-left: 24px">答题卡</span>
                  <!-- 模拟试题有 -->
                  <div
                    class="clear_btn"
                    v-if="!jxLoadingAll && !isMiNuo"
                    @click="startBgin(1)"
                  >
                    <img
                      src="../../assets/img/lajitong.png"
                      style="width: 14px; height: 14px"
                    />
                    <div>重做</div>
                  </div>
                </div>
                <!-- <div style="margin-right: 28px; position: relative">
                  <el-popover placement="bottom" :width="160" trigger="click">
                    <template #reference>
                      <img
                        src="../../assets/img/shezhi.png"
                        style="width: 24px; height: 24px; cursor: pointer"
                      />
                    </template>
                    <div>
                      <p style="cursor: pointer">
                        自动展开解析
                        <el-switch @change="changechecked" v-model="ischecked" />
                      </p>
                    </div>
                  </el-popover>
                </div> -->
              </div>
              <div class="question_content_right">
                <div v-if="radioArr.length != 0">
                  <div class="question_type_title">单选题</div>
                  <el-row :gutter="0" class="question_wrap">
                    <el-col
                      :span="4"
                      v-for="(item, index) in radioArr"
                      :key="index"
                    >
                      <div
                        class="question_number"
                        @click="toTopic(1, index, item)"
                        :style="{
                          borderColor: getColor('borderColor', item),
                          background: getColor('background', item),
                          color: getColor('color', item),
                        }"
                      >
                        {{ index + 1 }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="checkboxArr.length != 0">
                  <div class="question_type_title">多选题</div>
                  <el-row :gutter="0" class="question_wrap">
                    <el-col
                      :span="4"
                      v-for="(item, index) in checkboxArr"
                      :key="index"
                    >
                      <div
                        class="question_number"
                        @click="toTopic(2, index, item)"
                        :style="{
                          borderColor: getColor('borderColor', item),
                          background: getColor('background', item),
                          color: getColor('color', item),
                        }"
                      >
                        {{ index + 1 }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="decideArr.length != 0">
                  <div class="question_type_title">判断题</div>
                  <el-row :gutter="0" class="question_wrap">
                    <el-col
                      :span="4"
                      v-for="(item, index) in decideArr"
                      :key="index"
                    >
                      <div
                        class="question_number"
                        @click="toTopic(3, index, item)"
                        :style="{
                          borderColor: getColor('borderColor', item),
                          background: getColor('background', item),
                          color: getColor('color', item),
                        }"
                      >
                        {{ index + 1 }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="termArr.length != 0">
                  <div class="question_type_title">不定项</div>
                  <el-row :gutter="0" class="question_wrap">
                    <el-col
                      :span="4"
                      v-for="(item, index) in termArr"
                      :key="index"
                    >
                      <div
                        class="question_number"
                        @click="toTopic(4, index, item)"
                        :style="{
                          borderColor: getColor('borderColor', item),
                          background: getColor('background', item),
                          color: getColor('color', item),
                        }"
                      >
                        {{ index + 1 }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="subArr.length != 0">
                  <div class="question_type_title">主观题</div>
                  <el-row :gutter="0" class="question_wrap">
                    <el-col
                      :span="4"
                      v-for="(item, index) in subArr"
                      :key="index"
                    >
                      <div
                        class="question_number"
                        @click="toTopic(5, index, item)"
                        :style="{
                          borderColor: getColor('borderColor', item),
                          background: getColor('background', item),
                          color: getColor('color', item),
                        }"
                      >
                        {{ index + 1 }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
                <div v-if="comArr.length != 0">
                  <div class="question_type_title">综合题</div>
                  <el-row :gutter="0" class="question_wrap">
                    <el-col
                      :span="4"
                      v-for="(item, index) in comArr"
                      :key="index"
                    >
                      <div
                        class="question_number"
                        @click="toTopic(6, index, item)"
                        :style="{
                          borderColor: getColor('borderColor', item),
                          background: getColor('background', item),
                          color: getColor('color', item),
                        }"
                      >
                        {{ index + 1 }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <div class="" style="max-height: 190px; margin-bottom: 15px;position: absolute;bottom: 0;width: 100%;">
              <el-divider style="border: 1px solid #eaeaea"></el-divider>
              <!-- 章节练习 判断显示 -->
              <div class="question_mark_wrap" v-if="false">
                <div class="question_mark">
                  <div class="mark_done"></div>
                  <div>已做</div>
                </div>
                <div class="question_mark">
                  <div class="mark_nodone"></div>
                  <div>未做</div>
                </div>
              </div>
              <!-- 模拟试题 -->
              <div class="question_mark_wrap" v-if="!jxLoadingAll">
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  v-for="(item, index) in cardType"
                  :key="index"
                >
                  <div
                    class="circle-topic"
                    :style="{ borderColor: item.border, background: item.color }"
                  ></div>
                  <div style="margin-left: 5px">{{ item.text }}</div>
                </div>
              </div>
              <div class="question_mark_wrap" v-else>
                <div
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  "
                  v-for="(item, index) in cardType1"
                  :key="index"
                >
                  <div
                    class="circle-topic"
                    :style="{ borderColor: item.border, background: item.color }"
                  ></div>
                  <div style="margin-left: 5px">{{ item.text }}</div>
                </div>
              </div>

              <div class="paper_btn" v-if="!jxLoadingAll" @click="submit()">
                交卷
              </div>
              <div class="paper_btn" v-if="jxLoadingAll" @click="startBgin()">
                重新练习
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Header from "@/components/Header.vue";
  import WangEditor from 'wangeditor';
  import { fillAnswers, createUserPaperTest, handExam, paperDetailExam, quDetailExercise } from '@/api/apper.js'
// import {
//   cancelData,
//   getdetail,
//   qAlist,
//   quSubDetail,
//   reqAdd,
//   reQADetails,
//   updateAsk,
// } from '@api/index.js';

  import blue from '../../assets/practice/round-blue.png';
  import green from '../../assets/practice/round-green.png';
  import red from '../../assets/practice/round-red.png';
  import black from '../../assets/practice/round.png';
  import blue1 from '../../assets/practice/square-blue.png';
  import green1 from '../../assets/practice/square-green.png';
  import red1 from '../../assets/practice/square-red.png';
  import black1 from '../../assets/practice/square.png';
  import createKityformula from '../../components/EditorComponent/kityformula.js';
  import myscriptMath from '../../components/EditorComponent/myscript-math-web.js';
  import { formatDuring, formatSends } from '../../utils/dateUtils';

  export default {
    name: "apper",
    components: { Header },
    data() {
      return {
        userPaperId: '',
        currentNum: 1,// 当前题index
        userPaperId: "", //试卷id
        apperId: "", //试卷id
        jointId: "", //节
        ischecked: false, //是否开启自动解析
        isshow: false, //头部弹出
        name: "", //标题
        startTime: "", //试卷总时长保存
        listQu: [], //题目id列表
        listQuTypeNum: [], //题目数量列表
        docType: 1, //1 单选 2多选 3判断 4主观题
        indexNum: 1, //当前分页序号
        numArr: [], //保存所有分类总数量
        detail: {}, //试题详情
        quId: "", //问题id
        reLoading: false, //答题卡状态
        jxLoading: false, //解析状态
        jxLoadingAll: false, //全局解析开启
        result: [], //选择结果
        answers: [], //客观题答案
        answerstr: "", //主观题答案
        ansersCode: "", //客观题答案 a b c d
        cureCode: "", //正确答案
        radioArr: [], //单选id列表
        checkboxArr: [], //单选id列表
        decideArr: [], //单选id列表
        termArr: [], //不定项
        subArr: [], //主观
        comArr: [], //综合题
        leftSeconds: 0, //倒计时
        ratevalue: 4, //星星数量
        quIdCom: "", //问题id
        dataAreaShow: true, // 资料区显示隐藏
        isChange: 0, // 要求的选中index
        askdetail: {}, // 要求里的详情
        infoRichText: false,// 解析初始化富文本
        editor: null,
        editorDom: null,
        editorData: '',
        editorDomAns: null,
        editorAns: '',
        textareaValue: '',
        askShow: false,
        iaskShow: false,
        iaskNoShow: false,
        tabName: "相关问答",
        tabValue: '1',
        radioArrCom: [], //单选id列表
        checkboxArrCom: [], //单选id列表
        decideArrCom: [], //单选id列表
        termArrCom: [], //不定项
        subArrCom: [], //主观题
        docTypeCom: 1, //1 单选 2多选 3判断 4不定项选择 5富文本
        resultCom: [], //选择结果
        answersCom: [], //客观题答案
        answerstrCom: "", //主观题答案
        ansersCodeCom: "", //客观题答案 a b c d
        cureCodeCom: "", //正确答案
        jxLoadingCom: false, // 富文本解析状态
        centerDialogVisible: false,
        activeNames: "0", // 章节index
        initFBool: false, // 初始化富文本
        active: "1", // 标记tab
        askData: [], // 问答提问列表
        loadingOcr: false,
        iaskType: 0, // 0追问 1提问
        quesId: "", // 问题id
        showProbe: false,// 追问是否展示
        updataInputShow: false,// 修改提交文本框
        textareaUpdata: "",// 修改追加
        probeId: "",// 修改追问id
        noMoreOcr: false,
        docTypeOld: 1, // 旧的docType
        docTypeNew: 1, // 新的docType
        appendData: [], // 追问数据
        isInfiniteScroll: false, // 控制滚动禁用
        categoryId: "",
        askparam: {
          pageNum: 1,
          pageSize: 10,
          categoryId: "",
          quId: "",
          self: null,
        },
        chaName: '',
        categoryName: '',
        practiceTestShow: true,
        isReferenAnalysis: true,
        timer: 0, //计时器
        timerName: "", //交卷的时间保存到内存中，查看解析直接获取
        cardType: [
          {
            color: "#3e63ee",
            border: "#3e63ee",
            id: 3,
            textColor: "#ffffff",
            text: "已答",
          },
          {
            color: "#ffffff",
            border: "#EAEAEA",
            id: 2,
            textColor: "#000000",
            text: "未答",
          },
        ],
        cardType1: [
          {
            color: "#28BEBE",
            border: "#28BEBE",
            id: 0,
            textColor: "#ffffff",
            text: "正确",
          },
          {
            color: "#EB6C48",
            border: "#EB6C48",
            id: 1,
            textColor: "#ffffff",
            text: "错误",
          },
          {
            color: "#ffffff",
            border: "#EAEAEA",
            id: 2,
            textColor: "#000000",
            text: "未答",
          },
        ],
        cardType2: [
          {
            color: "#3e63ee",
            border: "#3e63ee",
            id: 3,
            textColor: "#ffffff",
            text: "已答",
          },
          {
            color: "#ffffff",
            border: "#EAEAEA",
            id: 2,
            textColor: "#000000",
            text: "未答",
          },
        ],
        token: '',
        specId: '',
        isMiNuo: false,
      }
    },
    watch: {
      docType: {
        handler(newValue, oldValue) {
          this.docTypeOld = oldValue
          this.docTypeNew = newValue
        }
      },
      isChange: {
        handler(newValue, oldValue) {
          this.addanswerCom(this.detail.quSubList[oldQuestion])
        }
      }
    },
    created() {
      this.token = window.localStorage.getItem('token')
      this.specId = JSON.parse(localStorage.getItem('specId'))
      if (this.$route.query.ksid) {
        this.specId = this.$route.query.ksid
        localStorage.setItem('specId', this.specId)
      }
      this.apperId = this.$route.query.apperId
      this.userPaperId = this.$route.query.userPaperId
      this.chaName = this.$route.query.chaName
      this.categoryName = this.$route.query.categoryName
      if(!this.chaName){
        this.chaName = sessionStorage.getItem('chaName')
      }
      // this.categoryId = getCache("categoryId")
      // if(!this.categoryName){
      //   this.categoryName = sessionStorage.getItem('categoryName')
      // }
      this.jxLoadingAll = this.$route.query.jxLoadingAll || false
      this.jxLoading = this.$route.query.jxLoadingAll || false
      if(this.jxLoadingAll || this.jxLoading){
        this.isReferenAnalysis = true
      }
      this.jxLoadingCom = this.$route.query.jxLoadingAll || false
      this.addcreateUserPaper()
    },
    methods: {
      // 倒计时函数
      endStart(item) {
        this.startTime = item;
        this.name = formatDuring(item);
        if (this.timer) {
          clearInterval(this.timer);
        }
        this.timer = setInterval(() => {
          item -= 1;
          this.name = formatDuring(item);
          if (item <= 0) {
            clearInterval(this.timer)
            this.$alert(`考试时间已结束，系统将自动交卷`,'提示',
              {
                center: true,
                confirmButtonText: '确认',
                confirmButtonClass:"confirm-button",
              }
            );
            //如果用户未点击交卷 3秒自动交卷
            setTimeout(() => {
              console.log("倒计时提交")
              if (this.docType == 6) {
                this.addanswerCom(this.detail.quSubList[this.isChange])
              } else {
                this.addanswer() //提交当前题
              }
              // addanswer(); //提交当前题
              this.handexerciseadd(1) //提交试卷
            }, 3000)
          }
        }, 1000)
      },

      //当前绑定的图片函数
      checkBoxImg(checked, item) {
        let url = "";
        let b = this.ansersCode.indexOf(item.abc) > -1 //判断是不否选中
        if (this.docType == 1 || this.docType == 3) {
          //单选和判断
          if (!this.jxLoading) {
            //解析之前  只有蓝色和黑色  解析之后只有绿色和红色并且不能修改
            b ? (url = blue) : (url = black)
            if (this.ansersCode == "" && item.checked) url = blue
          } else {
            this.ansersCode.indexOf(item.abc) > -1 ? (url = red) : (url = black)
            item.isRight ? (url = green) : ""
          }
        } else if (this.docType == 2 || this.docType == 4) {
          //多选
          if (!this.jxLoading) {
            b ? (url = blue1) : (url = black1)
            if (this.ansersCode == "" && item.checked) url = blue1
          } else {
            this.ansersCode.indexOf(item.abc) > -1 ? (url = red1) : (url = black)
            item.isRight ? (url = green1) : ""
          }
        }
        return url
      },

      //点击操作更新颜色  black  blue  green  red
      checkColor(item) {
        let color = "";
        let b = this.ansersCode.indexOf(item.abc) > -1 //判断是不否选中
        if (this.docType == 1 || this.docType == 3) {
          //单选和判断
          if (!this.jxLoading) {
            //解析之前  只有蓝色和黑色  解析之后只有绿色和红色并且不能修改
            b ? (color = "blue") : (color = "black");
            if (this.ansersCode == "" && item.checked) color = "blue"
          } else {
            b ? (color = "red") : (color = "black")
            item.isRight ? (color = "green") : ""
          }
        } else if (this.docType == 2 || this.docType == 4) {
          //多选
          if (!this.jxLoading) {
            b ? (color = "blue") : (color = "black")
            if (this.ansersCode == "" && item.checked) color = "blue";
          } else {
            b ? (color = "red") : (color = "black")
            item.isRight ? (color = "green") : ""
          }
        }
        return color
      },

      //jxLoadingAll没有开启解析证明答题卡只有做和没做两种状态
      getColor(type, item) {
        let aaa = "";
        //判断试卷是否结束  jxLoadingAll=true结束  jxLoadingAll=false未结束
        if (this.jxLoadingAll) {
          if (type == "borderColor") {
            aaa =
              item.answered == 1
                ? item.isRight == 1
                  ? this.cardType1[0].border
                  : this.cardType1[1].border
                  : this.cardType1[2].border
          } else if (type == "background") {
            aaa =
              item.answered == 1
                ? item.isRight == 1
                  ? this.cardType1[0].color
                  : this.cardType1[1].color
                  : this.cardType1[2].color
          } else if (type == "color") {
            aaa =
              item.answered == 1
                ? item.isRight == 1
                  ? this.cardType1[0].textColor
                  : this.cardType1[1].textColor
                  : this.cardType1[2].textColor
          }
        } else {
          // jxLoadingAll=false  未结束只有做和不做
          if (type == "borderColor") {
            aaa = item.answered == 1 ? this.cardType2[0].border : this.cardType2[1].border
          } else if (type == "background") {
            aaa = item.answered == 1 ? this.cardType2[0].color : this.cardType2[1].color
          } else if (type == "color") {
            aaa =
              item.answered == 1 ? this.cardType2[0].textColor : this.cardType2[1].textColor
          }
        }
        return aaa
      },

      //主观题更改答题卡状态  并提交
      async groupChange2() {
        if (this.answerstr != "" && this.answerstr != null) {
          this.subArr[this.indexNum - 1].answered = 1;
        } else {
          this.subArr[this.indexNum - 1].answered = 0;
        }
      },

      //更改答题卡状态函数  jxLoadingAll没有开启解析证明答题卡只有做和没做两种状态
      changeCardStatus() {
        console.log("答题卡状态修改")
        if (this.docType == 1) {
          if (this.answers.length > 0) {
            this.radioArr[this.indexNum - 1].answered = 1 //已经做了
            this.radioArr[this.indexNum - 1].isRight = this.answers[0].isRight ? 1 : 0
          } else {
            this.radioArr[this.indexNum - 1].answered = 0
          }
        } else if (this.docType == 2) {
          if (this.answers.length > 0) {
            this.checkboxArr[this.indexNum - 1].answered = 1
            //当前题所有ischecked属性和answers中一致才可以
            let aa = this.detail.answerList.map((item) => {
              if (item.isRight) {
                return item.abc
              }
            })
            let bb = this.answers.map((item) => item.abc)
            if (aa.toString() == bb.toString()) {
              this.checkboxArr[this.indexNum - 1].isRight = 1
            } else {
              this.checkboxArr[this.indexNum - 1].isRight = 0
            }
          } else {
            this.checkboxArr[this.indexNum - 1].answered = 0
          }
        } else if (this.docType == 3) {
          if (this.answers.length > 0) {
            this.decideArr[this.indexNum - 1].answered = 1
            this.decideArr[this.indexNum - 1].isRight = this.answers[0].isRight ? 1 : 0
          } else {
            this.decideArr[this.indexNum - 1].answered = 0
          }
        } else if (this.docType == 4) {
          if (this.answers.length > 0) {
            this.termArr[this.indexNum - 1].answered = 1
            //当前题所有ischecked属性和answers中一致才可以
            let aa = this.detail.answerList
              .map((item) => {
                if (item.isRight) {
                  return item.abc
                }
              })
              .filter(Boolean);
            let bb = this.answers.map((item) => item.abc)
            if (aa.toString() == bb.toString()) {
              this.termArr[this.indexNum - 1].isRight = 1
            } else {
              this.termArr[this.indexNum - 1].isRight = 0
            }
          } else {
            this.termArr[this.indexNum - 1].answered = 0
          }
        }else if(this.docType == 6){
          this.comArr[this.indexNum - 1].answered = 1
        }
      },

      //提交试卷
      handexerciseadd(index = 0) {
        handExam({ id: this.userPaperId, flag: index }, { Authorization: this.token }).then((res) => {
          localStorage.setItem("timerName", this.name) //交卷保存当前时间
          localStorage.setItem("updatetime", formatDuring(this.startTime - formatSends(this.name)))
          // sessionStorage.setItem('categoryName', this.categoryName)
          sessionStorage.setItem('chaName', this.chaName)
          clearInterval(this.timer)
          if (this.isMiNuo) {
            this.$router.push(
              "/report?userPaperId=" + this.userPaperId + "&apperId=" + this.apperId + "&chaName=" + this.chaName + "&listQu=" + this.listQu.length 
            );
          } else {
            this.$router.push(
              "/result?userPaperId=" + this.userPaperId + "&apperId=" + this.apperId + "&chaName=" + this.chaName + "&listQu=" + this.listQu.length 
            );
          }
          console.log("已经提交")
        }).catch(res => {
          this.$message.error(res)
        })
      },

      //进行答题 插入题
      async addanswer() {
        let arr = this.answers.map((item) => item.answerId)
        //本地保存当前答题状态
        //单选和判断  直接判断answers中的值isRight是不是true 如果是正确，不是就错误arr.length==0未答
        if (this.jxLoadingAll) {
          return
        }
        if (this.docTypeNew != 5 && this.docType != 6 && this.result.length == 0) {
          return
        } 
        if (this.docTypeNew == 5 && !this.answerstr) {
          return
        }
        await fillAnswers({
          userPaperId: this.userPaperId,
          quId: this.quId,
          answers: arr,
          answer: this.answerstr, //主观题答案
        }, { Authorization: this.token })
        console.log("答案提交了");
        this.answers = [] //清空
        this.result = [] //清空
        console.log("提交", this.answers)
      },

      //计算答题卡未答数量
      getNotAnswer() {
        let count = 0;
        this.radioArr.map((item) => {
          if (item.answered == 0) {
            count++
          }
        })
        this.checkboxArr.map((item) => {
          if (item.answered == 0) {
            count++
          }
        })
        this.decideArr.map((item) => {
          if (item.answered == 0) {
            count++
          }
        })
        this.termArr.map((item) => {
          if (item.answered == 0) {
            count++
          }
        })
        this.subArr.map((item) => {
          if (item.answered == 0) {
            count++
          }
        })
        this.comArr.map((item) => {
          if (item.answered == 0) {
            count++
          }
        })
        return count
      },

      //提交答题卡
      submit() {
        let c = this.getNotAnswer();
        if (c == 0) {
          this.$confirm(`当前题已全部作答，是否确认交卷？`,"提示",
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              confirmButtonClass:"confirm-button",
              cancelButtonClass:"cancel-button",
              center: true,
              type: 'warning',
            }
          ).then(() => {
            if(this.docType == 6){
              this.addanswerCom(this.detail.quSubList[this.isChange]).then(() => {
                this.handexerciseadd(); //提交试卷
              });
            }else{
              //提交当前题
              this.addanswer().then(() => {
                this.handexerciseadd(); //提交试卷
              });
            }
          }).catch(() => {})
          // if(this.docType == 6){
          //   this.addanswerCom(this.detail.quSubList[this.isChange]).then(() => {
          //     this.handexerciseadd() //提交试卷
          //   });
          // }else{
          //   //提交当前题
          //   this.addanswer().then(() => {
          //     this.handexerciseadd() //提交试卷
          //   });
          // }
        } else {
          this.$confirm(`您还有${c}题未作答，是否确认交卷？`,"提示",
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              confirmButtonClass:"confirm-button",
              cancelButtonClass:"cancel-button",
              center: true,
              type: 'warning',
            }
          ).then(() => {
            if(this.docType == 6){
              this.addanswerCom(this.detail.quSubList[this.isChange]).then(() => {
                this.handexerciseadd(); //提交试卷
              });
            }else{
              //提交当前题
              this.addanswer().then(() => {
                this.handexerciseadd(); //提交试卷
              });
            }
          }).catch(() => {})
        }
      },

      //通过indexNum和docType 获取对应的quid值
      getQuid() {
        let quId = "";
        switch (this.docType) {
          case 1:
            {
              quId = this.radioArr[this.indexNum - 1].quId
            }
            break
          case 2:
            {
              quId = this.checkboxArr[this.indexNum - 1].quId
            }
            break
          case 3:
            {
              quId = this.decideArr[this.indexNum - 1].quId
            }
            break
          case 4:
            {
              quId = this.termArr[this.indexNum - 1].quId
            }
            break
          case 5:
            {
              quId = this.subArr[this.indexNum - 1].quId
            }
            break
          case 6:
            {
              quId = this.comArr[this.indexNum - 1].quId
            }
            break
        }
        return quId
      },
      
      //获取试卷详情   类型进行修改
      getdetailFun(type) {
        const quIdstr = this.getQuid()
        this.quId = quIdstr
        if(this.jxLoadingAll){
          this.tabValue = '1'
          // this.resetMyQA()
        }
        quDetailExercise({ userPaperId: this.userPaperId, quId: quIdstr }, { Authorization: this.token }).then((res) => {
          console.log("试题", res)
          this.detail = res.data
          if(type == 6 || this.docType == 6){
            if(this.detail.quSubList && this.detail.quSubList[0]){
              this.getChangeAsk(this.detail.quSubList[0])
            }
          }
          //获取试题正确答案编号 cureCode
          this.cureCode = ""
          this.ansersCode = ""
          res.data.answerList && res.data.answerList.map((item) => {
            if (item.isRight) {
              this.cureCode += item.abc + ","
            }
            //获取用户选择的答案编号
            if (item.checked) {
              this.ansersCode += item.abc + ","
            }
          })
          this.cureCode = this.cureCode.substring(0, this.cureCode.length - 1)
          this.ansersCode = this.ansersCode.substring(0, this.ansersCode.length - 1)
          //主观题赋值
          this.answerstr = res.data.answer
        })
      },

      //首屏请求
      getCharperList(id) {
        paperDetailExam({ jointId: this.jointId, id: id }, { Authorization: this.token }).then((res) => {
          console.log("题目列表", res);
          this.isMiNuo = res.data.isFormal == 1 ? false : true
          res.data.listQu && res.data.listQu.forEach((item,index) => {
            item.index = index + 1
          });
          this.listQu = res.data.listQu;
          this.docType = res.data.listQu[0].quType; //第一个题型不是单选题的话
          this.listQuTypeNum = res.data.listQuTypeNum;
          this.leftSeconds = res.data.leftSeconds; //倒计时
          if (!this.jxLoadingAll) {
            this.endStart(res.data.leftSeconds);
          } else {
            this.name = localStorage.getItem('timerName')  //查看解析从内存获取
            // this.name = getCache("timerName"); 
          }
          if (res.data.listQu.length == 0) {
            console.log("没有题目");
            return;
          }
          this.numArr = [0, 0, 0, 0, 0, 0]; //6个分类分别保存num总数
          //分类存储
          res.data.listQu.map((item) => {
            if (item.quType == 1) {
              this.radioArr.push(item) //单选
              this.numArr[0] += 1
            } else if (item.quType == 2) {
              this.checkboxArr.push(item) //多选
              this.numArr[1]++
            } else if (item.quType == 3) {
              this.decideArr.push(item) //判断
              this.numArr[2]++
            } else if (item.quType == 4) {
              this.termArr.push(item) //不定项
              this.numArr[3]++
            } else if (item.quType == 5) {
              this.subArr.push(item) //主观
              this.numArr[4]++
            }else if(item.quType == 6) {
              this.comArr.push(item) //综合题
              this.numArr[5]++
            }
          })
          console.log("this.numArr", this.numArr)
          //首次获取index编号的题
          this.getdetailFun()
        })
      },
      
      //创建试卷
      addcreateUserPaper() {
        if (this.jxLoadingAll) {
          this.getCharperList(this.userPaperId)
        } else {
          createUserPaperTest({ id: this.apperId }, { Authorization: this.token }).then((res) => {
            console.log("试卷", res)
            if (res.code == 0 || res.code == 200) {
              this.userPaperId = res.data.id
              this.getCharperList(res.data.id)
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },

      //返回
      onClickLeft() {
        if (this.jxLoadingAll) {
          this.$router.push("/result?userPaperId=" + this.userPaperId + "&apperId=" + this.apperId + "&chaName=" + this.chaName + "&listQu=" + this.listQu.length)
          // this.$router.push(`/exam/${this.apperId}?ksid=${this.specId}`)
          return
        }
        let c = this.getNotAnswer()
        let msg = c == 0 ? '当前题已全部作答，是否确认交卷？' : `您还有${c}题未作答，是否确认交卷？`
        this.$confirm(msg,'提示',
          {
            confirmButtonText: '确认',
            cancelButtonText: '取消',
            confirmButtonClass:"confirm-button",
            cancelButtonClass:"cancel-button",
            center: true,
            type: 'warning',
          }
        ).then(() => {
          this.addanswer().then(() => {
            //提交当前题
            this.handexerciseadd() //提交试卷
          });
        }).catch(() => {})
      },

      //答题卡下钻
      toTopic(type, index, item) {
        if (this.currentNum == item.index) {
          return false
        }
        this.currentNum = item.index
        this.isChange = 0
        this.docType = type
        this.indexNum = index + 1
        this.addanswer()
        this.getdetailFun(type)
        this.reLoading = false
        this.jxLoadingAll ? (this.jxLoading = true) : (this.jxLoading = false)
      },

      //上一题
      lastTopic() {
        if(this.currentNum == 1){
          this.currentNum = 1
        }else{
          this.currentNum --
        }
        if (this.indexNum == 1 && this.docType == 1) {
          this.$alert('已到第一题','提示',{
            confirmButtonText: '确定',
            confirmButtonClass:"confirm-button",
            center: true,
          })
          return
        }
        if (this.indexNum == 1) {
          for (var i = this.docType - 1; i >= 0; i--) {
            if (this.numArr[i - 1] > 0) {
              this.indexNum = this.numArr[i - 1]
              this.docType = i
              break
            }
          }
        } else {
          this.indexNum--
        }
        this.askparam.pageNum = 1
        if(this.docTypeNew == 6){
          this.addanswerCom(this.detail.quSubList[this.isChange])
        }else{
          this.addanswer()
        }
        this.isChange = 0
        this.getdetailFun()
        this.jxLoadingAll ? (this.jxLoading = true) : (this.jxLoading = false)
        this.initFBool = false // 切换上下题时富文本框置空
      },

      sumArr(arr) {
        var s = 0
        for (var i = arr.length - 1; i >= 0; i--) {
          s += arr[i]
        }
        return s
      },

      //下一题
      nextTopic() {
        const con = this.numArr[this.docType - 1] //当前值
        const sum = this.numArr.slice(this.docType, this.numArr.length)
        const con1 = this.sumArr(sum)
        if (con1 == 0 && this.indexNum == con) {
          //判断之后有没有值
          if (this.jxLoadingAll) {
            this.$alert('已到最后一题', '提示', {
              confirmButtonText: '确定',
              confirmButtonClass:"confirm-button",
              center: true,
            })
            return
          }
          let c = this.getNotAnswer()
          console.log(this.docType,'cccccccc')
          if (c == 0) {
            this.$confirm(`当前题已全部作答，是否确认交卷？`,"提示",
              {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                confirmButtonClass:"confirm-button",
                cancelButtonClass:"cancel-button",
                center: true,
                type: 'warning',
              }
            ).then(() => {
              if(this.docType == 6){
                this.addanswerCom(this.detail.quSubList[this.isChange]).then(() => {
                  this.handexerciseadd(); //提交试卷
                });
              }else{
                //提交当前题
                this.addanswer().then(() => {
                  this.handexerciseadd(); //提交试卷
                });
              }
            }).catch(() => {})
            // if(this.docType == 6){
            //   this.addanswerCom(this.detail.quSubList[this.isChange]).then(() => {
            //     this.handexerciseadd(); //提交试卷
            //   })
            // }else{
            //   this.addanswer().then(() => {
            //     //提交当前题
            //     this.handexerciseadd() //提交试卷
            //   })
            // }
            return
          } else {
            this.$confirm(`您还有${c}题未作答，是否确认提交？`,"提示",
              {
                confirmButtonText: '确认',
                cancelButtonText: '取消',
                confirmButtonClass:"confirm-button",
                cancelButtonClass:"cancel-button",
                center: true,
                type: 'warning',
              }
            ).then(() => {
              if(this.docType == 6){
                this.addanswerCom(this.detail.quSubList[this.isChange]).then(() => {
                  this.handexerciseadd() //提交试卷
                })
              }else{
                //提交当前题
                this.addanswer().then(() => {
                  this.handexerciseadd() //提交试卷
                })
              }
            }).catch(() => {
              this.addanswer(); //提交当前题
            })
            return
          }
        } else if (this.indexNum == con) {
          for (var i = this.docType; i <= 5; i++) {
            if (this.numArr[i] > 0) {
              this.indexNum = 1
              this.docType = i + 1
              break
            }
          }
        } else {
          this.indexNum++
        }
        console.log(this.docTypeOld,this.docTypeNew,'docTypeComdocTypeComdocTypeCom3333')
        if(this.docTypeNew <= 5){
          this.addanswer()
        }else{
          if(this.isChange == 0){
            this.addanswerCom(this.detail.quSubList[this.isChange])
          }
        }
        this.isChange = 0
        this.jxLoadingAll ? (this.jxLoading = true) : (this.jxLoading = false) //前进后退 解析都隐藏
        this.getdetailFun()
        this.initFBool = false // 切换上下题时富文本框置空
        if(this.currentNum == this.listQu.length){
          this.currentNum = this.listQu.length
        }else{
          this.currentNum ++
        }
      },

      //主观题状态修改
      groupChang2() {
        if (this.answerstr != "" && this.docType == 4) {
          if (this.answers.length > 0) {
            this.subArr[this.indexNum - 1].answered = 1
          } else {
            this.subArr[this.indexNum - 1].answered = 0
          }
        }
      },

      //选择操作  请求接口更改当前答案状态  修改当前选中状态  获取选中编号
      groupChange(e) {
        if (this.jxLoading) {
          return
        }
        if (this.docType != 2 && this.docType != 4 && e.length > 1) {
          this.result.shift()
        }
        this.answers = e
        this.ansersCode = ""
        this.answers.map((item) => {
          this.ansersCode += item.abc + ","
        })
        this.ansersCode = this.ansersCode.substring(0, this.ansersCode.length - 1)
        if (this.answers.length > 0) {
          this.changeCardStatus()
        }
      },

      //交卷
      openJie() {
        let c = this.getNotAnswer()
        if (c == 0) {
          this.$confirm(`当前题已全部作答，是否确认交卷？`,"提示",
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              confirmButtonClass:"confirm-button",
              cancelButtonClass:"cancel-button",
              center: true,
              type: 'warning',
            }
          ).then(() => {
            this.addanswer().then(() => {
              //提交当前题
              this.handexerciseadd() //提交试卷
            })
          }).catch(() => {})
          return
        } else {
          this.$confirm(`您还有${c}题未作答，是否确认提交？`,'提示',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              confirmButtonClass:"confirm-button",
              cancelButtonClass:"cancel-button",
              center: true,
              type: 'warning',
            }
          ).then(() => {
            this.addanswer().then(() => {
              //提交当前题
              this.handexerciseadd() //提交试卷
            })
          }).catch(() => {})
          return
        }
      },

      //从新开始
      startBgin(flag) {
        if(flag == 1){
          this.$confirm(`是否清空当前答题卡记录，并返回第一题重新做题?`,'提示',
            {
              confirmButtonText: '确认',
              cancelButtonText: '取消',
              confirmButtonClass:"confirm-button",
              cancelButtonClass:"cancel-button",
              center: true,
              type: 'warning',
            }
          ).then(() => {
            // this.$router.go(0)
            window.location.reload()
            // this.$router.push("/apper?apperId=" + this.apperId + "&chaName=" + this.chaName)
            // location.href = "/apper?apperId=" + this.apperId + "&flag=" + flag + "&chaName=" + this.chaName
          }).catch(() => {})
        }else{
          // this.$router.go(0)
          this.$router.push("/apper?apperId=" + this.apperId + "&chaName=" + this.chaName)
          window.location.reload()
          // location.href = "/apper?apperId=" + this.apperId + "&flag=" + flag + "&chaName=" + this.chaName
        }
      },

      // 富文本区
      checkColorCom(item) {
        let color = "";
        let b = this.ansersCodeCom.indexOf(item.abc) > -1 //判断是不否选中
        if (this.docTypeCom == 1 || this.docTypeCom == 3) {
          //单选和判断
          if (!this.jxLoading) {
            //解析之前  只有蓝色和黑色  解析之后只有绿色和红色并且不能修改
            b ? (color = "blue") : (color = "black")
            if (this.ansersCodeCom == "" && item.checked) color = "blue"
          } else {
            b ? (color = "red") : (color = "black")
            item.isRight ? (color = "green") : ""
          }
        } else if (this.docTypeCom == 2 || this.docTypeCom == 4) {
          //多选
          if (!this.jxLoading) {
            b ? (color = "blue") : (color = "black");
            if (this.ansersCodeCom == "" && item.checked) color = "blue"
          } else {
            b ? (color = "red") : (color = "black")
            item.isRight ? (color = "green") : ""
          }
        }
        return color
      },

      //当前绑定的图片函数
      checkBoxImgCom(checked, item) {
        // console.log(checked,item,jxLoading.value);
        let url = "";
        let b = this.ansersCodeCom.indexOf(item.abc) > -1; //判断是不否选中
        console.log("ansersCode", this.ansersCodeCom);
        if (this.docTypeCom == 1 || this.docTypeCom == 3) {
          //单选和判断
          if (!this.jxLoading) {
            //解析之前  只有蓝色和黑色  解析之后只有绿色和红色并且不能修改
            b ? (url = blue) : (url = black)
            if (this.ansersCodeCom == "" && item.checked) url = blue
          } else {
            this.ansersCodeCom.indexOf(item.abc) > -1 ? (url = red) : (url = black)
            item.isRight ? (url = green) : ""
          }
        } else if (this.docTypeCom == 2 || this.docTypeCom == 4) {
          //多选
          if (!this.jxLoading) {
            b ? (url = blue1) : (url = black1)
            if (this.ansersCodeCom == "" && item.checked) url = blue1
          } else {
            this.ansersCodeCom.indexOf(item.abc) > -1 ? (url = red1) : (url = black)
            item.isRight ? (url = green1) : ""
          }
        }
        return url
      },

      groupChangeCom(e) {
        if (this.jxLoading) {
          return
        }
        if (this.docTypeCom != 2 && this.docTypeCom != 4 && e.length > 1) {
          this.resultCom.shift();
        }
        this.answersCom = e
        this.ansersCodeCom = ""
        this.answersCom.map((item) => {
          this.ansersCodeCom += item.abc + ","
        })
        this.ansersCodeCom = this.ansersCodeCom.substring(0, this.ansersCodeCom.length - 1)
        // console.log('点击操作',this.answers);
        // this.askData = []
        // this.getQuesAsk()
        if (this.answersCom.length > 0) {
          this.changeCardStatus()
        }
      },
            
      // 没有数据的提问
      iaskNoClick() {
        this.iaskNoShow = true
        this.updataInputShow = false
        this.iaskType = 1
      },

      // 相关问答区
      // 我的问答切换tab
      tabClick(e) {
        this.iaskShow = false
        this.noMoreOcr  = false
        this.updataInputShow = false
        this.tabName = e.props.label
        this.askparam.pageNum = 1
        this.askparam.pageSize = 10
        this.askparam.self = null
        this.askData = []
        if(e.props.label == '我的问答'){
          this.askparam.self = '1'
        }else{
          this.askparam.self = null
        }
        this.getQuesAsk()
      },
      
      // 重置我的问答
      resetMyQA() {
        // tabValue.value = '1'
        this.askparam.pageNum = 1
        this.askparam.pageSize = 10
        this.askparam.self = null
        this.askData = []
        this.noMoreOcr = false
        this.initFBool = false
        this.getQuesAsk()
      },
      
      // 获取全部问答
      getAllClick() {
        // this.askparam.pageNum = 1
        // this.askparam.pageSize = 10
        this.askparam.self = this.tabName == '我的问答' ? '1' : null
        // this.askData = []
        this.closeAll()
        this.getQuesAsk()
      },
      closeAll() {
        this.iaskShow = false
        this.textareaValue = ""
        this.updataInputShow = false
        this.textareaUpdata = ""
      },

      // 展开收起追问 
      changeAskShow(item) {
        this.item.checked = !item.checked
        this.askShow = !this.askShow
        if(item.checked){
          this.getReQADetails(item.id,null,item)
        }
      },

      // 取消提问
      clearQuesClick(data,type) {
        cancelData(data.id).then(res=>{
          this.$message.success('取消提问成功')
          // this.getAllClick()
          this.closeAll()
          this.resetMyQA()
          if(type == 1){
            this.askShow.value = true
            this.getReQADetails(data.id,type)
          }
        })
      },

      // 取消
      clearClick() {
        this.textareaValue = ""
        this.iaskShow = false
        this.iaskNoShow = false
      },
      
      // 编辑取消
      clearClickUpdata() {
        this.textareaUpdata = ""
        this.updataInputShow = false
      },

      // 提交
      subClick() {
        // categoryId.value
        // categoryId = "11"
        // quId = "0054371f934447dd83994e87dce1c25b"
        if (this.textareaValue) {
          reqAdd({
            id: this.iaskType == 0 ? this.quesId : null,
            quId: this.quId,
            categoryId: this.categoryId,
            contents: this.textareaValue,
            businessType: 1,
          }).then(res=>{
            this.$message.success('提交成功')
            this.resetMyQA()
            this.textareaValue = ""
            this.iaskShow = false
            this.iaskNoShow = false
            if(this.iaskType == 0){
              this.getReQADetails(this.quesId)
              this.askShow = true
            }
          })
        } else {
          this.$message.error('提问内容不能为空')
        }
      },

      // 我要提问 type 0追问 1提问
      iaskClick(type,data) {
        this.quesId = data && data.id
        this.iaskType = type
        this.iaskShow = true
        this.updataInputShow = false
      },
      
      // 修改追问
      updataAskQue(item) {
        this.probeId = item.id
        this.iaskNoShow = false
        this.iaskShow = false
        this.textareaUpdata = item.contents
        this.updataInputShow = true
      },

      // 提交修改
      subClickUpdata() {
        if (this.textareaUpdata) {
          updateAsk({ 
            id: this.probeId,
            contents: this.textareaUpdata 
          }).then(res=>{
            this.$message.success('修改成功')
            this.resetMyQA()
            this.textareaUpdata = ""
            this.updataInputShow = false
          })
        } else {
          this.$message.error('提问内容不能为空')
        }
      },

      // 转义字符串中特殊字符
      htmlDecodeByRegExp(str) {  
        var s = ""
        if(str.length == 0) return ""
        s = str.replace(/&amp;/g,"&")
        s = s.replace(/&lt;/g,"<")
        s = s.replace(/&gt;/g,">")
        s = s.replace(/&nbsp;/g," ")
        s = s.replace(/&#39;/g,"\'")
        s = s.replace(/&quot;/g,"\"")
        s = s.replace(/\n/g,"<br/>")
        return s
      },

      // 获取提问列表
      getQuesAsk() {
        this.askparam.categoryId = this.categoryId 
        this.askparam.quId = this.quId
        this.askparam.self = this.tabName == '我的问答' ? 1 : null
        this.askparam.open = this.tabName == '我的问答' ? null : 1
        this.askparam.businessType = 1
        qAlist(askparam).then(res=>{
          res && res.data.forEach(item=>{
            item.checked = false
            item.appendData = []
            item.showProbe = true
          })
          this.loadingOcr = false
          this.askData = [...this.askData, ...res]
          this.askData.forEach(item => {
            item.contents = this.htmlDecodeByRegExp(item.contents)
          })
          this.askparam.pageNum += 1
          if(res.data.length == 0){
            this.noMoreOcr  = true
            this.isInfiniteScroll = true
            return false
          }
          this.isInfiniteScroll = false
        })
      },
      
      // 根据id获取追问追答列表
      getReQADetails(parentId,type, data) {
        let params = {
          self: this.tabName == '我的问答' ? 1 : null,
          parentId,
        }
        reQADetails(params).then(res=>{
          console.log(res,'追问追答列表')
          if(res.data.length == 0 && !type && this.tabValue !== '1'){
            this.$confirm(
              `该提问暂无详情，可点击追问按钮对该问题进行追问`,
              '提示',
            {
              confirmButtonText: '知道了',
              cancelButtonText: '取消',
              confirmButtonClass:"confirm-button",
              cancelButtonClass:"cancel-button",
              center: true,
              type: 'warning',
            }).then(() => {}).catch(() => {})
          }
          res.data.forEach(item => {
            item.contents = this.htmlDecodeByRegExp(item.contents)
          })
          data.appendData = res
          this.appendData = res
          data.showProbe = res.data.length == 0 ? true : false
          this.showProbe = res.data.length == 0 ? true : false
        })
      },
      
      // 资料区显示隐藏
      dataAreaClick() {
        this.dataAreaShow = !this.dataAreaShow
      },
      
      // 切换要求
      changeAsk(ty,item) {
        let index = ty == 0 ? ty : ty - 1
        this.isChange = ty;
        if(this.infoRichText){
          this.editorDomAns.destroy()
          this.infoRichText = false
        }
        this.jxLoadingAll ? (this.jxLoadingCom = true) : (this.jxLoadingCom = false);
        this.getChangeAsk(this.detail.quSubList[ty],index)
      },

      //进行答题
      async addanswerCom(quSubId) {
        const arr = this.answersCom.map((item) => item.answerId)
        if (this.jxLoadingAll) {
          return
        }
        if (this.docTypeCom != 5 && this.resultCom.length == 0) {
          return
        }
        //本地保存当前答题状态
        //单选和判断  直接判断answers中的值isRight是不是true 如果是正确，不是就错误arr.length==0未答
        const res = await fillAnswers({
          userPaperId: this.userPaperId,
          quId: this.quIdCom,
          answers: arr,
          quSubId,
          answer: this.docTypeCom == 5 ? this.answerstrCom : null, //主观题答案
          // answer: docTypeNew == 5 ? answerstrCom : null, //主观题答案
        }, { Authorization: this.token });
        console.log("答案提交了")
        this.answersCom = [] //清空
        this.resultCom = [] //清空
        console.log("提交", this.answers)
      },
      
      // 获取要求
      getChangeAsk(quId,index) {
        quDetailExercise({
          userPaperId: this.userPaperId,
          quId
        }, { Authorization: this.token }).then(res=>{
          console.log('要求',res)
          this.quIdCom = res.data.quId
          this.askdetail = res
          this.detail.analysis = res.data.analysis
          this.docTypeCom = res.data.quType
          if(this.jxLoadingAll){
            this.tabValue = '1'
            this.resetMyQA()
          }
          if(this.jxLoadingAll && this.docTypeCom == 5){
            // editorData = editor.txt.html()
            this.editorData = res.data.answer
            this.getCompreMyanswer(this.editorData)
          }
          //获取试题正确答案编号 cureCode
          this.cureCodeCom = ""
          this.ansersCodeCom = ""
          this.resultCom = [] //选中的 回显整个数据
          res.data.answerList && res.data.answerList.map((item) => {
            if (item.isRight) {
              this.cureCodeCom += item.abc + ","
            }
            //获取用户选择的答案编号
            if (item.checked) {
              this.ansersCodeCom += item.abc + ","
              this.resultCom.push(item)
            }
          });
          this.cureCodeCom = this.cureCodeCom.substring(0, this.cureCodeCom.length - 1)
          this.ansersCodeCom = this.ansersCodeCom.substring(0, this.ansersCodeCom.length - 1)
          //主观题赋值
          // answerstrCom = res.data.answer;
          //上一页 下一页时候，判断多选的解析要不要打开
          //判断条件：1.右上角自动解析打开，result回显有值
          if (this.ischecked && this.resultCom.length != 0) {
            this.jxLoading = true;
            this.jxLoadingCom = true;
          }
          if(res.data.quType == 5 && !this.jxLoadingAll){
            console.log(res.data.answer,'res.data.answerres.data.answer')
            this.getComprehensive(res.data.answer)
          }
          if(res.data.quType == 5 && this.jxLoadingAll){
            this.getCompreMyanswer(res.data.answer)
          }
        })
      },

      // 展开收起解析
      collapseHandler() {
        this.isReferenAnalysis = !this.isReferenAnalysis
      },
      
      // 富文本展示
      getComprehensive(val) {
        nextTick(()=>{
          // if(!initFBool.value){ 
          var editorDiv = document.getElementById('demo1')
          if(editorDiv.offsetHeight == 0){
            var editordoms = new WangEditor('#demo1')
            this.editorDom = editordoms
            this.editorDom.config.menus = [
              // "head",
              // "bold",
              // "fontSize",
              // "fontName",
              "italic",
              "underline",
              "strikeThrough",
              "indent",
              "lineHeight",
              "foreColor",
              "backColor",
              "link",
              "list",
              "justify",
              "quote",
              // "image",
              "table",
              "code",
              "splitLine",
              "undo",
              "redo",
              "kityformulaKey",
              "myscriptKey",
            ]
            const { $ } = WangEditor
            const { PanelMenu, Panel } = WangEditor
            class Kityformula extends PanelMenu {
              // 公式输入插件
              constructor (editors) {
                const $elem = WangEditor.$(
                  `<div class="w-e-menu noPosition">
                      <i class="iconfont icon-icongongshi" style="font-size:18px;"></i>
                    </div>`
                )
                super($elem, editors)
              }

              // 菜单点击事件
              clickHandler () {
                // 做任何你想做的事情
                // 可参考【常用 API】文档，来操作编辑器
                const conf = createKityformula(this.editorDom)
                const panel = new Panel(this, conf)
                panel.create()
              }

              tryChangeActive () {}
            }

            class Myscript extends PanelMenu {
              // 公式手写插件
              constructor (editors) {
                const $elem = WangEditor.$(
                  `<div class="w-e-menu noPosition">
                      <i class="iconfont icon-iconshouxieban" style="font-size:18px;"></i>
                  </div>`
                )
                super($elem, editors)
              }

              // 菜单点击事件
              clickHandler () {
                // 做任何你想做的事情
                // 可参考【常用 API】文档，来操作编辑器
                const conf = myscriptMath(editor)
                const panel = new Panel(this, conf)
                panel.create()
              }

              tryChangeActive () {}
            }

            // 注册菜单
            const kityformulaKey = 'kityformulaKey' // 菜单 key ，各个菜单不能重复
            this.editorDom.menus.extend('kityformulaKey', Kityformula)

            // 注册菜单
            const myscriptKey = 'myscriptKey' // 菜单 key ，各个菜单不能重复
            this.editorDom.menus.extend('myscriptKey', Myscript)

            // 将菜单加入到 editor.config.menus 中
            // 也可以通过配置 menus 调整菜单的顺序，参考【配置菜单】部分的文档
            this.editorDom.config.menus = this.editorDom.config.menus.concat(kityformulaKey)
            this.editorDom.config.menus = this.editorDom.config.menus.concat(myscriptKey)

            this.editorDom.config.uploadImgShowBase64 = true
            this.editorDom.config.uploadImgMaxLength = 5 // 一次最多上传 5 个图片

            // 配置 onchange 回调函数，将数据同步到 vue 中
            this.editorDom.config.onchange = newHtml => {
              this.answerstrCom = newHtml
              if(answerstrCom){
                this.comArr[this.indexNum - 1].answered = 1;
              }
              console.log(this.answerstrCom,'newHtml')
            }
            // 创建编辑器
            this.editorDom.create()
            this.editor = this.editorDom
            this.editor.txt.clear()
            if(val){
              this.editor.txt.html(val)
            }
            this.initFBool = true
          }else{
            this.editor = this.editorDom
            this.editor.txt.clear()
            if(val){
              this.editor.txt.html(val)
            }
          }
        })
      },
      
      // 答案回显富文本
      getCompreMyanswer(val) {
        nextTick(()=>{
          if(!this.infoRichText){
            console.log('editorDomAns====', this.editorDomAns)
            var editordoms = new WangEditor('#demo2')
            this.editorDomAns = editordoms
            this.editorDomAns.config.menus = []
            // 配置 onchange 回调函数，将数据同步到 vue 中
            this.editorDomAns.config.onchange = newHtml => {
              this.answerstrCom = newHtml
              if(this.answerstrCom){
                this.comArr[this.indexNum - 1].answered = 1;
              }
              console.log(this.answerstrCom,'newHtml')
            }
            // 创建编辑器
            this.editorDomAns.create()
            this.editorDomAns.disable()
            this.editorAns = this.editorDomAns
            this.editorAns.txt.clear()
            if(val){
              this.editorAns.txt.html(val)
            }
            this.infoRichText = true
          }else{
            // editorAns = this.editorDom
            this.editorAns = this.editorDomAns
            this.editorAns.txt.clear()
            if(val){
              this.editorAns.txt.html(val)
            }
          }
        })
      },
    },
    destroyed() {
      clearInterval(this.timer)
    },
  }
</script>

<style>
  .confirm-button{
    width: 148px !important;
    height: 44px !important; 
    background: #3E63EE !important;
    border: 1px solid #3E63EE !important;
    border-radius: 6px !important;
    padding: 0 !important;
    line-height: 40px !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    color: #FFFFFF !important;
  }
  .confirm-button:hover{
    background: #3E63EE !important;
    font-weight: 400 !important;
    color: #FFFFFF !important;
  }
  .cancel-button{
    width: 148px !important;
    height: 44px !important;
    border-radius: 6px !important;
    border: 1px solid #3E63EE !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    color: #3E63EE !important;
    line-height: 40px !important;
    padding: 0 !important;
  }
  .cancel-button:hover{
    border: 1px solid #3E63EE !important;
    font-size: 18px !important;
    font-weight: 400 !important;
    color: #3E63EE !important;
  }
  .el-tabs--border-card{
    border: 1px solid #CBCBCB;
    border-radius: 14px;
  }
  .el-tabs__header{
    border-radius: 14px 14px 0 0;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item:first-child{
    border-radius: 14px 0 0 0;
    border: 1px solid #CBCBCB;
    border-right: none;
    border-bottom: none;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item:last-child{
    border:none;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active{
    font-size: 18px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }
  .el-tabs--border-card>.el-tabs__header .el-tabs__item{
    font-size: 18px;
    height: 50px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #666666;
  }
  .el-tabs--border-card>.el-tabs__header{
    background: #F5F5F5;
    border-bottom: none;
  }
  .el-tabs__item:hover{
    color: #666666 !important;
  }
  .information_class {
    table {
      border-collapse: collapse;
      th, td {
        border: 1px solid #ddd;
        height: 23px;
        line-height: 23px;
        text-align: center;
        /* user-select: none; */
        min-width: 70px;
      }
    }
  }
  /* .el-tabs__content{
    height: 300px !important;
    overflow-y: auto;
  } */
</style>

<style lang="less" scoped>
  .exam-wrapper {
    width: 1200px;
    margin: 0 auto;
    margin-top: 120px;
  }
  .pro_header{
    width: 100%;
    
    .modal_class{
      padding-left: 35px;
      display: flex;
      height: 68px;
      line-height: 68px;
      background: #FFFFFF;
      border-radius: 8px;
      border: 1px solid #F0F0F3;
      .back_class{
        width: 72px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      .title_class{
        font-size: 22px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        flex: 1;
        padding-left: 15px;
        padding-right: 20px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
  .wrap {
    width: 100%;
    height: calc(100vh - 220px);
    margin-top: 10px;
    display: flex;
    justify-content: space-between;

    .question_type {
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .question_clear {
        width: 68px;
        height: 24px;
        background: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 12px;
        border: 1px solid #4f79ed;
        line-height: 22px;
        margin-right: 40px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4f79ed;
      }
      .identify {
        display: inline-block;
        width: 6px;
        height: 24px;
        background: #3e63ee;
        border-radius: 3px;
      }
      .name {
        display: inline-block;
        font-size: 23px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #333333;
        margin-left: 34px;
      }
    }
    .question_type_right {
      height: 32px;
      line-height: 32px;
      display: flex;
      align-items: center;
      // justify-content: space-between;
      .identify {
        display: inline-block;
        width: 6px;
        height: 24px;
        background: #3e63ee;
        border-radius: 3px;
      }
      .name {
        display: inline-block;
        font-size: 23px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #666666;
        margin-left: 34px;
      }
      .clear_btn {
        display: flex;
        align-items: center;
        width: 68px;
        height: 24px;
        background: #ffffff;
        border-radius: 12px;
        border: 1px solid #4f79ed;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #4f79ed;
        justify-content: center;
        margin-left: 18px;
        cursor: pointer;
      }
    }
    .topic {
      width: 62%;
      display: flex;
      flex-direction: column;
      /* justify-content: space-between; */
      background: #ffffff;
      border-radius: 8px;
      border: 1px solid #eaeaea;
      padding: 24px 0px 24px 0;
      .content_wrap {
        display: flex;
        flex-direction: column;
        height: calc(100% - 20px);
        .content_inner {
          height: 100%;
          overflow-x: hidden;
          overflow-y: auto;
          padding-bottom: 15px;
        }
      }
      .information_wrap{
        margin-top: 10px;
        margin-right: 20px;
        margin-left: 20px;
        .information_title{
          display: flex;
          justify-content: space-between;
          font-size: 18px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
        }
        .information_class{
          width: 100%;
          padding: 15px;
          margin-top: 5px;
          max-height: 260px;
          overflow-y: auto;
          background: #FFFFFF;
          border-radius: 14px;
          border: 1px solid #E8E8E8;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
        .answer_class{
          display: flex;
          justify-content: space-between;
          margin-bottom: 10px;
          :first-child{
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #666666;
          }
        }
        .page{
          display: flex;
          margin-bottom: 5px;
          .btns {
            min-width: 60px;
            height: 32px;
            border-radius: 8px;
            border: 1px solid #A8B3BC;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #A8B3BC;
            line-height: 30px;
            text-align: center;
            margin-right: 5px;
            cursor: pointer;
          }
          .act {
            background: #3E63EE;
            border-radius: 8px;
            border: 1px solid #4F79ED;
            font-weight: 400;
            color: #FFFFFF;
          }
        }
      }
      .question_content {
        margin-top: 30px;
        .title {
          margin-left: 40px;
          font-size: 21px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-bottom: 25px;
        }
        .option_content {
          margin-right: 40px;

          .option_item {
            width: 100%;
            height: 40px;
            // padding: 5px 5px 5px 10px;
            margin-left: 29px;
            background: white;
            // border-radius: 6px;
            :hover {
              background: #f3f6ff;
            }
          }
          ::v-deep .el-radio {
            width: 100%;
            border-radius: 6px;
            height: 40px;
            line-height: 40px;
            margin-left: 29px;
          }
          ::v-deep .el-radio__input.is-checked + .el-radio__label {
            color: #0f6cf5;
          }
          .el-radio-error {
            color: #eb6c48;
          }
          ::v-deep .el-radio__label {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            padding: 15px;
          }
          ::v-deep .el-radio__input.is-checked .el-radio__inner {
            background-color: white;
            border-color: #0f6cf5;
          }
          ::v-deep .el-radio__inner {
            width: 22px;
            height: 22px;
          }
          ::v-deep .el-radio__input.is-checked .el-radio__inner::after {
            content: "";
            width: 10px;
            height: 5px;
            border: 3px solid #0f6cf5;
            border-top: transparent;
            border-right: transparent;
            text-align: center;
            display: inline-block;
            position: absolute;
            top: 5px;
            left: 4px;
            vertical-align: middle;
            transform: rotate(-45deg);
            border-radius: 0px;
            background: none;
          }
          ::v-deep .el-checkbox {
            width: 100%;
            border-radius: 6px;
            height: auto;
            // line-height: 40px;
            margin-left: 29px;
            padding-left: 5px;
          }
          ::v-deep .el-checkbox__label {
            font-size: 22px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            /* margin-top: 2px; */
          }
          ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
            background-color: #0f6cf5;
          }
          ::v-deep .el-checkbox__input.is-checked + .el-checkbox__label {
            color: #0f6cf5;
          }
          ::v-deep .el-checkbox__inner {
            width: 22px;
            height: 22px;
          }
          ::v-deep .el-checkbox__inner::after {
            height: 13px;
            left: 8px;
          }
        }
        .compreh_p {
          margin-left: 40px;
          padding-right: 40px;
          width: 100%;
          font-size: 20px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
        .determine_wrap {
          width: 100%;
          display: flex;
          justify-content: flex-end;
          margin-top: 10px;
          .determine_btn {
            width: 108px;
            height: 44px;
            background: #3e63ee;
            border-radius: 6px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            text-align: center;
            line-height: 44px;
          }
        }
        .resizeNone {
          ::v-deep .el-textarea__inner {
            resize: none;
          }
        }
      }
      .parse_style {
        margin-top: 30px;
        .title {
          margin-left: 40px;
          font-size: 21px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          margin-bottom: 25px;
        }
        .parse_content {
          margin-right: 40px;
          margin-left: 70px;
          .parse_item {
            width: 100%;
            height: 40px;

            background: white;
            border-radius: 6px;
            display: flex;
            cursor: pointer;
            align-items: center;
            .parse_label {
              width: 100%;
              margin-left: 15px;
            }
          }
          .parse_item:hover {
            background: #f3f6ff;
            border-radius: 6px;
          }
          .parse_error {
            color: #eb6c48;
            font-size: 21px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
          .parse_success {
            color: #28bebe;
            font-size: 21px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
          }
        }
      }
      .question_btn {
        display: flex;
        justify-content: space-between;
        margin: 0 40px;
        margin-top: 15px;
        .left_btn {
          display: flex;
          :first-child {
            width: 108px;
            height: 44px;
            line-height: 40px;
            text-align: center;
            background: #ffffff;
            border-radius: 6px;
            border: 1px solid #3e63ee;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            cursor: pointer;
            color: #3e63ee;
          }
          :last-child {
            width: 108px;
            height: 44px;
            margin-left: 20px;
            line-height: 40px;
            text-align: center;
            background: #3e63ee;
            border-radius: 6px;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #ffffff;
            cursor: pointer;
          }
        }
        .right_analysis {
          margin-right: 40px;
          position: relative;
          cursor: pointer;
          display: flex;
          justify-content: center;
          width: 108px;
          height: 44px;
          line-height: 40px;
          background: #ffffff;
          border-radius: 6px;
          border: 1px solid #3e63ee;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #3e63ee;
        }
      }

      .pars_content {
        margin: 10px 30px 0px 30px;
        .pars_title {
          width: 134px;
          height: 44px;
          background: #eb6c48;
          border-radius: 8px 8px 0px 0px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
        }
        .pars_title_success {
          width: 134px;
          height: 44px;
          background: #28bebe;
          border-radius: 8px 8px 0px 0px;
          text-align: center;
          line-height: 44px;
          font-size: 16px;
          font-family: PingFangSC-Semibold, PingFang SC;
          font-weight: 600;
          color: #ffffff;
        }
        .pars_middle {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: calc(100% - 17px);
          height: 110px;
          background: #f8f8f8;
          border-radius: 0px 8px 8px 8px;
          padding-right: 20px;
          // opacity: 0.04;

          .pars_answer {
            display: flex;
            .pars_inner {
              width: 125px;
              height: 47px;
              text-align: center;
              .pars_text {
                font-size: 19px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #303b45;
              }
            }
          }
          .view_resolu_wrap {
            height: 35px;
            cursor: pointer;
            .view_resolut {
              display: flex;
              align-items: center;
              font-size: 19px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #303b45;
            }
          }
          .pars_text_success {
            font-size: 23px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #28bebe;
          }
          .pars_text_info {
            font-size: 23px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #eb6c48;
          }
        }
        .reference_class {
          margin-top: 12px;
          width: calc(100% - 38px);
          // max-height: 220px;
          background: #ffffff;
          overflow-y: auto;
          border-radius: 14px;
          border: 1px solid #cbcbcb;
          padding: 10px 20px 20px 20px;
          .reference_top {
            display: flex;
            justify-content: space-between;
            .reference_title {
              font-size: 19px;
              display: flex;
              align-items: center;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #666666;
              img{
                margin-right: 10px;
              }
            }
          }
          .reference_p {
            margin-top: 10px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
          .reference_title_two {
            display: flex;
            align-items: center;
            margin-top: 15px;
            font-size: 18px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #666666;
            img{
              margin-right: 10px;
            }
          }
          .reference_bottom {
            width: 360px;
            height: auto;
            background: #ffffff;
            border-radius: 6px;
            border: 1px solid #cbcbcb;
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 38px;
            text-align: center;
            margin-top: 10px;
            overflow: hidden;
          }
        }
        .answerbom_wrap{
          width: 100%;
          text-align: center;
          span{
            display: inline-block;
            cursor: pointer;
            margin-top: 12px;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #848F9A;
          }
          .btn{
            width: 60%;
            height: 44px;
            margin: 0 auto;
            background: #3E63EE;
            border-radius: 6px;
            text-align: center;
            line-height: 42px;
            cursor: pointer;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #FFFFFF;
            margin-top: 20px;
          }
          .btns{
            display: flex;
            justify-content: flex-end;
            margin-top: 10px;
            :first-child{
              width: 90px;
              cursor: pointer;
              height: 40px;
              border-radius: 6px;
              border: 1px solid #3E63EE;
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #3E63EE;
              line-height: 38px;
              text-align: center;
              margin-right: 10px;
            }
            :last-child{
              width: 90px;
              height: 40px;
              cursor: pointer;
              background: #3E63EE;
              border-radius: 6px;
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              text-align: center;
              line-height: 38px;
            }
          }
        }
        .berelated_wrap{
          p{
            cursor: pointer;
            margin-top: 12px;
            text-align: center;
            font-size: 16px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #848F9A;
          }
          .backgront_item{
            background: #F5F5F5;
            border-radius: 14px;
            padding: 10px 5px 10px 5px;
            margin-top: 10px;
          }
          .berelated_item{
            width: 100%;
            .ask_wrap{
              display: flex;
              width: 100%;
              // min-width: 450px;
              .ask_title{
                font-size: 16px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 700;
                color: #333333;
                word-wrap: break-word;
              }
            }
            img{
              width: 30px;
              height: 28px;
              margin-right: 14px;
              margin-top: 5px;
            }
            .ask_time{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #606A74;
              margin-top: 5px;
              cursor: pointer;
            }
            .cancel_ques{
              font-size: 14px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #3e63ee;
              margin-top: 5px;
              cursor: pointer;
              margin-right: 10px;
            }
            .answer_wrap{
              display: flex;
              width: 100%;
              margin-top: 10px;
              .da_title{
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #666666;
                white-space: pre-wrap;
              }
            }
          }
          .nodata{
            width: 100%;
            text-align: center;
            position: relative;
            div{
              position: relative;
              top: -30px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #848F9A;
            }
            .btn{
              width: 108px;
              height: 44px;
              margin: 0 auto;
              background: #3E63EE;
              border-radius: 6px;
              text-align: center;
              line-height: 42px;
              cursor: pointer;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #FFFFFF;
              margin-top: 12px;
            }
            .btns{
              display: flex;
              justify-content: flex-end;
              margin-top: 10px;
              :first-child{
                width: 90px;
                cursor: pointer;
                height: 38px;
                border-radius: 6px;
                border: 1px solid #3E63EE;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #3E63EE;
                line-height: 36px;
                text-align: center;
                margin-right: 10px;
              }
              :last-child{
                width: 90px;
                height: 38px;
                cursor: pointer;
                background: #3E63EE;
                border-radius: 6px;
                font-size: 18px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #FFFFFF;
                text-align: center;
                line-height: 36px;
              }
            }
          }
        }
      }
    }
    .option {
      width: 36%;
      height: 100%;
      // max-height: 785px;
      // background: #FFFFFF;
      // border-radius: 8px;
      // border: 1px solid #EAEAEA;
      display: flex;
      flex-direction: column;
      // justify-content: space-between;
      .option_wrap {
        border-radius: 8px;
        min-height: 600px;
        border: 1px solid #eaeaea;
        display: flex;
        background-color: white;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        .question_content_right {
          padding: 0 30px;
          height: calc(100% - 200px);
          overflow-y: auto;
          .question_type_title {
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            margin: 24px 0 21px 0px;
          }
          .question_wrap {
            width: 100%;
            .question_number {
              //已做
              cursor: pointer;
              max-width: 32px;
              width: 32px;
              height: 32px;
              background: #4f79ed;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              border: 1px solid #EAEAEA;
              border-radius: 16px;
              text-align: center;
              line-height: 31px;
              margin: 0 auto 14px auto;
            }
            .question_number_notdone {
              //未做
              cursor: pointer;
              width: 32px;
              height: 32px;
              background: white;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #333333;
              border-radius: 16px;
              text-align: center;
              line-height: 31px;
              margin: 0 auto 14px auto;
              border: 1px solid #eaeaea;
            }
            .question_number_success {
              cursor: pointer;
              width: 32px;
              height: 32px;
              background: #28bebe;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              border-radius: 16px;
              text-align: center;
              line-height: 31px;
              margin: 0 auto 14px auto;
              border: 1px solid #eaeaea;
            }
            .question_number_error {
              cursor: pointer;
              width: 32px;
              height: 32px;
              background: #eb6c48;
              font-size: 16px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #ffffff;
              border-radius: 16px;
              text-align: center;
              line-height: 31px;
              margin: 0 auto 14px auto;
              border: 1px solid #eaeaea;
            }
          }
        }
        .question_mark_wrap {
          display: flex;
          justify-content: space-around;
          margin-bottom: 30px;
          .question_mark {
            display: flex;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            .mark_done {
              width: 18px;
              height: 18px;
              border-radius: 9px;
              background: #4f79ed;
              margin-right: 10px;
            }
            .mark_nodone {
              width: 18px;
              height: 18px;
              border-radius: 9px;
              border: 2px solid #eaeaea;
              margin-left: 50px;
              margin-right: 10px;
            }
            .mark_success {
              width: 18px;
              height: 18px;
              border-radius: 9px;
              background: #28bebe;
              margin-right: 10px;
            }
            .mark_error {
              width: 18px;
              height: 18px;
              border-radius: 9px;
              margin-left: 50px;
              background: #eb6c48;
              margin-right: 10px;
            }
          }
        }
        .paper_btn {
          width: 85%;
          height: 44px;
          margin: 0 auto;
          background: #3e63ee;
          border-radius: 6px;
          text-align: center;
          line-height: 44px;
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .answer_timer {
        width: 100%;
        height: 82px;
        min-height: 80px;
        background: #ffffff;
        border-radius: 8px;
        border: 1px solid #eaeaea;
        margin-bottom: 15px;
        display: flex;
        align-items: center;
        .answer_type {
          display: flex;
          align-items: center;
          .identify {
            display: inline-block;
            width: 6px;
            height: 24px;
            background: #3e63ee;
            border-radius: 3px;
          }
          .name {
            display: inline-block;
            font-size: 23px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #666666;
            margin-left: 10px;
          }
        }
        ::v-deep .el-statistic__content {
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #666666;
        }
      }
    }
    .duoxuanti {
      width: fit-content;
      border-radius: 8px;
      border: 1px solid #4f79ed;
      margin: 15px 30px;
      width: 60px;
      height: 30px;
      text-align: center;
      line-height: 28px;
      color: #4f79ed;
      font-size: 15px;
      cursor: pointer;
    }
    .box-item {
      // padding: 10px;
      background: #f8f8f8;
      border-radius: 14px;
      margin-top: 10px;
      border: 1px solid #f8f8f8;
      ::v-deep .el-checkbox__input {
        display: none;
      }
    }
    .img-icon {
      width: 15px;
      height: 15px;
    }
    .box-item-green {
      border: 1px solid #28bebe;
    }

    .box-item-blue {
      border: 1px solid #4f79ed;
    }

    .box-item-red {
      border: 1px solid #eb6c48;
    }
    .box-text {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      width: 100%;
      white-space: break-spaces;
      line-height: 20px;
      padding: 10px;
    }

    .box-text-blue {
      color: #4f79ed;
    }

    .box-text-green {
      color: #28bebe;
    }

    .box-text-red {
      color: #eb6c48;
    }
    .img-icon {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
    .circle-topic {
      border-radius: 50%;
      width: 25px;
      height: 25px;
      border: 3px solid #eaeaea;
      display: flex;
      flex-wrap: nowrap;
    }
    .zg_con {
      width: 100%;
      height: 100px;
      margin-top: 10px;
      margin-left: 40px;
      border-color: #CBCBCB;
      border-radius: 14px;
      padding: 10px 18px;
      &:focus {
        outline: none;
      }
    }
  }
</style>